import api from '../Utils/api';

export interface Skin {
    created: string;
    id: string;
    name: string;
    active: boolean;
    value: Value;
}

export interface Value {
    color_primary: string;
    icon_dark: string;
    icon_light: string;
    id: string;
    logo_dark: string;
    logo_light: string;
    name: string;
    show_detail_shape: boolean;
}

const skinsService = {
    getSkin: async (): Promise<{ skins: Skin[] }> => {
        return api.get(`/v1/skins`);
    },
};

export default skinsService;
